<script>
  // import { Router, Link, Route } from "svelte-routing"
  import router from 'page'
  import Home from './components/pages/Index.svelte'
  import About from './components/pages/About.svelte'
  import Services from './components/pages/Services.svelte'
  import History from './components/pages/History.svelte'
  import Contact from './components/pages/Contact.svelte'
  import Nav from './components/parts/nav.svelte'
  import Login from './components/pages/Login.svelte'
  import Signup from './components/pages/Signup.svelte'
  import Events from './components/pages/Events.svelte'
  import VideoEvents from './components/pages/VideoEvents.svelte'
  import MPanel from './components/pages/MPanel.svelte'
  import MSearch from './components/pages/MSearch.svelte'
  import Logout from './components/pages/Logout.svelte'
  import E404 from './components/utility/404.svelte'
  import Matrimonial from './components/pages/Matrimonial.svelte';
  import MatrimonialSearch from "./components/pages/MatrimonialSearch.svelte"
  import ViewMatrimonialDetails from "./components/pages/ViewMatrimonialDetails.svelte"

  let page
  let routeName

  function titleName(routeParam) {
    let bannerName = routeParam.split('/')

    return bannerName[bannerName.length - 1].replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    })
  }

  router(
    '/',
    (ctx, next) => {
      routeName = 'Home'
      next()
    },
    () => (page = Home)
  )
  router(
    '/about',
    (ctx, next) => {
      routeName = titleName(ctx.path)
      next()
    },
    () => (page = About)
  )
  router(
    '/services',
    (ctx, next) => {
      routeName = titleName(ctx.path)
      next()
    },
    () => (page = Services)
  )
  router(
    '/history',
    (ctx, next) => {
      routeName = titleName(ctx.path)
      next()
    },
    () => (page = History)
  )
  router(
    '/contact',
    (ctx, next) => {
      routeName = titleName(ctx.path)
      next()
    },
    () => (page = Contact)
  )

  router(
    '/home',
    (ctx, next) => {
      routeName = titleName(ctx.path)
      next()
    },
    () => (page = Hero2)
  )

  router(
    '/login',
    (ctx, next) => {
      routeName = titleName(ctx.path)
      next()
    },
    () => (page = Login)
  )

  router(
    '/logout',
    (ctx, next) => {
      routeName = titleName(ctx.path)
      next()
    },
    () => (page = Logout)
  )

  router(
    '/signup',
    (ctx, next) => {
      routeName = titleName(ctx.path)
      next()
    },
    () => (page = Signup)
  )
 

  router(
    '/emanager',
    (ctx, next) => {
      routeName = titleName(ctx.path)
      next()
    },
    () => (window.location.href = 'http://event.dsaana.org/')
  )
  router('/matrimonial',() => (page = Matrimonial))
  router('/matrimonialsearch',() => (page = MatrimonialSearch))
  router('/viewmatrimonialdetails',() => (page = ViewMatrimonialDetails))
  router('/members', () => (page = MPanel))
  router('/search', () => (page = MSearch))
  router('/events', () => (page = Events))
  router('/videoevent', () => (page = VideoEvents))

  router('/*', () => (page = E404))

  router.start()
</script>

<Nav />

<svelte:component this="{page}" title="{routeName}" />

<style>
  @font-face {
    font-family: 'H1Font';
    src: url('../assets/fonts/vinque.ttf');
  }
  :global(h1, h2) {
    font-family: 'H1Font';
  }

  :global(body) {
    background-image: url(../assets/images/old-paper.jpg);
    background-size: cover;
    background-repeat: no-repeat;
  }
</style>
